import { AppShell } from '@/components/app-shell';
import { Outlet } from 'react-router-dom';

export function DashboardLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
